export enum ExportFormatEnum {
  PDF = 'pdf',
  EXCEL = 'excel',
  CSV = 'csv',
  ZIP = 'zip',
  JPG = 'jpg',
  XLS = 'XLS',
}

export interface IExportOption {
  format: ExportFormatEnum;
  label: string;
  icon: string;
}
